import React from "react";
import TelegramIcon from "@/components/marketing/TelegramIcon";

const TELEGRAM_URL = "https://t.me/m/ClwANEMkNzU0";

/**
 * Floating circular Telegram contact button, fixed to the bottom-right
 * corner on every page. Renders above most fixed elements via z-index.
 * Raised clearance on mobile to avoid overlapping cookie banners etc.
 */
export default function FloatingTelegram() {
  return (
    <a
      href={TELEGRAM_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Message Digital24 on Telegram"
      className="fixed z-50 bottom-5 right-5 md:bottom-6 md:right-6 flex h-12 w-12 md:h-14 md:w-14 items-center justify-center rounded-full text-white shadow-[0_6px_20px_rgba(34,158,217,0.45)] hover:shadow-[0_8px_28px_rgba(34,158,217,0.6)] hover:scale-105 active:scale-95 transition-all duration-200"
      style={{ backgroundColor: "#229ED9" }}
    >
      <TelegramIcon className="w-6 h-6 md:w-7 md:h-7" />
    </a>
  );
}